<div class="tableInfo">
    <ng-container *ngIf="!isList">
    <p *ngIf="address"><strong *ngIf="label">{{label}} : </strong>
        <span
           *ngIf="address.length> lengthsplice">{{address.substring(0,lengthsplice)}}...</span>
        <span *ngIf="address.length<= lengthsplice">{{address}}</span>
     </p>
     <p *ngIf="!address">-</p>
    <a href="#" class="tip1 infoIcon" attr.data-tip="row{{index}}" data-placement="bottom"
        *ngIf="address && address.length> lengthsplice">
        <img src="assets/img/infoIcon.png" alt="">
    </a>
    <div id="row{{index}}" class="tip-content hidden" style="display: none;">
        <div class="tooltipSec">
            <p  [innerHTML]="address"></p>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isList">


    <p *ngIf="inputList && inputList.length > 0" style="text-align: left;">
        <span *ngFor="let list of inputList |slice: 0:lengthsplice">
          {{list.name}} <br>
        </span>
      </p>
      
      <a *ngIf="inputList && inputList.length>3" 
         href="#" class="tip1 infoIcon" attr.data-tip="forms{{index}}" data-placement="bottom">
         <img src="assets/img/infoIcon.png" alt="">
        +{{inputList.length - lengthsplice}} more...
      </a>

      <div id="forms{{index}}" class="tip-content hidden" style="display: none;">
       <div class="tooltipSec">
            <ul class="tooltipNameList">
               <li *ngFor ="let obj of inputList |slice: lengthsplice:inputList.length-1">{{obj.name}},</li>
               <li *ngFor ="let obj of inputList |slice: inputList.length-1 :inputList.length">{{obj.name}}</li>
            </ul>
             

       </div>
 </div>
</ng-container>

</div>
